<template>
<div>
	<div class="row" id="banner" style="margin: 0">
		<div class="container">
			<h1 class="display-5">第三方服务提供商企业项目追踪软件</h1>

			<ul class="list-unstyled">
				<li><el-icon class="el-icon-bell"/><span style="margin: 20px;">全方位项目状态查询</span></li>
				<li><el-icon class="el-icon-date"/><span style="margin: 20px;">跨部门项目管理</span></li>
				<li><el-icon class="el-icon-view"/><span style="margin: 20px;">工作流程和工作计划预设</span></li>
				<li><el-icon class="el-icon-view"/><span style="margin: 20px;">项目任务看板管理</span></li>
				<li><el-icon class="el-icon-document"/><span style="margin: 20px;">报表自动生成</span></li>
				<li><el-icon class="el-icon-document"/><span style="margin: 20px;">内置考勤以及考勤大数据系统应用</span></li>
			</ul>
			<p><a class="btn btn-primary btn-lg btn-warning" href="https://booking.adun.live/" target="_blank" role="button">免费试用 &raquo;</a></p>
		</div>
	</div>
	<main id="appMain" class="container" role="main">
		<div class="row row-offcanvas row-offcanvas-right">
			<div class="col-12 col-md-9">
				<p class="float-right d-md-none">
					<button class="btn btn-primary btn-sm" type="button" data-toggle="offcanvas">Toggle nav</button>
				</p>
				<ContentView/>
			</div>
			<div class="col-6 col-md-3 sidebar-offcanvas" id="sidebar">
					<div class="list-group">
						<router-link class="list-group-item active" :to="link">快速链接 »</router-link>
						<a class="list-group-item" href="https://blog.csdn.net/java_augur/article/details/119895403"  target="_blank">技术框架 »</a>
						<a class="list-group-item" href="/static/pdf/lims.pdf" download="lims.pdf">宣传手册 »</a>
						<a class="list-group-item" href="https://mail.adun.live" target="_blank">网上邮箱 »</a>
						<router-link class="list-group-item" to='/companyName'>公司命名工具 »</router-link>
						<a class="list-group-item" href="mailto:admin@adun.live?subject=技术支持&body=" rel="nofollow">技术支持 »</a>
					</div>
			</div>
		</div>
		<hr/>
	</main>
</div>
</template>
<script>
import ContentView from '@/components/ContentView'
export default {
  name: 'app',
  components: {
    ContentView
  },
  data () {
    return {
      link: 'link'
    }
  },
  methods: {
  }
}
</script>
<style scoped>
#appMain {
	position: relative;
	top: 10px;
}
#banner {
	background: url(../../static/assets/image/test-tubes-banner.jpg) no-repeat 50% 50%;
	background-size: cover;
	width: 100%;
	overflow:auto;
	color: white;
	height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/MainView.vue